import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cePaginaPrima } from "@/lib/indietro";

/**
 * Il tasto «Indietro» delle pagine fuori dal menu (06/10/2026): torna alla
 * pagina di prima se c'e', altrimenti alla pagina madre (`madre`), al posto di
 * restare fermo. Le regole e il perche' stanno in src/lib/indietro.ts.
 */
export function useIndietro(madre: string) {
  const navigate = useNavigate();
  // Si rilegge a ogni cambio di pagina: la scritta del tasto lo segue.
  useLocation();
  const puoTornare = cePaginaPrima();
  const torna = useCallback(() => {
    if (cePaginaPrima()) navigate(-1);
    else navigate(madre, { replace: true });
  }, [navigate, madre]);
  return { torna, puoTornare };
}
